document.querySelectorAll('.jl-marquee').forEach((marquee)=>{

    const track = marquee.querySelector('.jl-marquee__track');

    track.innerHTML += track.innerHTML;

    let position = 0;

    const speed = 0.6;

    function animate(){

        position -= speed;

        if(Math.abs(position) >= track.scrollWidth / 2){

            position = 0;

        }

        track.style.transform = `translateX(${position}px)`;

        requestAnimationFrame(animate);

    }

    animate();

    marquee.addEventListener('mouseenter',()=>{

        speedValue = 0;

    });

});